module.exports = __webpack_public_path__ + "static/media/yaworks.5874e9b7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/yaworks.webp
// module id = 807
// module chunks = 0